"use client"

import NextImage from "next/image"
import { useImageConfiguration } from "@/contexts/image-configuration/image-configuration.context"
import type { ArticleContentModel } from "@/services/api/content/models/article-content-model.types"
import { imageLoader } from "@/utilities/image/image-loader"

type SupportingImageProps = {
  readonly image: ArticleContentModel.SupportingImage
  readonly caption: null | string
  readonly sourceSetSize: string
}

export function SupportingImage({
  caption,
  image,
  sourceSetSize,
}: SupportingImageProps) {
  const { serverUrl } = useImageConfiguration()

  return (
    <figure>
      <div className="relative aspect-3/2 w-full">
        <NextImage
          alt={caption ?? ""}
          className="bg-whisper object-cover"
          fill={true}
          loader={imageLoader(serverUrl)}
          priority={true}
          sizes={sourceSetSize}
          src={image.aspectRatio3By2}
        />
      </div>
      {caption !== null ? (
        <figcaption className="pt-1 text-dim text-sm">{caption}</figcaption>
      ) : null}
    </figure>
  )
}
